<template>
  <div class="common-dialog-box" v-if="value" :style="{ zIndex: zIndex }">
    <div
      class="common-dialog-mask"
      :style="{ zIndex: zIndex }"
      @touchmove.prevent="() => {}"
    ></div>
    <div class="common-dialog" :style="{ zIndex: zIndex }">
      <div
        class="dialog-header"
        @touchmove.prevent="() => {}"
        v-if="!hideHeader"
      >
        <slot name="header">{{ title }}</slot>
      </div>
      <div class="dialog-content">
        <slot></slot>
      </div>
      <span v-if="!hideClose" class="vux-close" @click="closeDialog"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'common-dialog',
  data() {
    return {};
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 1000,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
  },
  watch: {},
};
</script>
<style lang="less" scoped>
.vux-close {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  color: #999;
  width: 0.3rem;
  height: 0.3rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  &:after,
  &:before {
    content: '';
    position: absolute;
    left: 0.08rem;
    top: 0.15rem;
    width: 0.15rem;
    height: 1px;
    background-color: currentColor;
    transform: rotate(-45deg);
  }
  &:after {
    transform: rotate(45deg);
  }
}
.common-dialog-box {
  .common-dialog-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .vux-close {
    color: #fff;
    position: absolute;
    bottom: -0.75rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .common-dialog {
    width: 3rem;
    max-width: 90%;
    overflow: visible;
    position: fixed;
    z-index: 5000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    text-align: center;
    border-radius: 3px;
    .dialog-header {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0 0.1rem;
      font-size: 0.16rem;
      color: #606060;
      position: relative;
      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 1px;
        border-bottom: 1px solid #e3e3e3;
        color: #e3e3e3;
        transform-origin: 0 100%;
        transform: scaleY(0.5);
      }
    }
    .dialog-content {
      padding: 0.25rem 0.1rem 0.25rem;
      text-align: center;
    }
  }
}
</style>
